module.exports = __webpack_public_path__ + "img/orange_114.f5e310b3.png";